import packageJson from "../package.json";

export const sdk_version = packageJson.version;
